module.exports = __webpack_public_path__ + "static/media/modifyDesktop.c59b9f8c.svg";